import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  removeProductAndTriggerAnalytics,
  removeAllProductsForSegmentAndTriggerAnalytics,
  showProductsComparision
} from '../../reduck/listingPageComparison.reduck';
import ComparePanel from '../ComparePanel/ComparePanel';
import { getActiveListingPage } from '../../reduck/selectors';
import { dispatchClickProductImage } from '../../analytics/compareAnalytics';

const Wrapper = styled.div`
  &.dc-sticky {
    display: block;
    position: static;
    width: 100%;
    transition: all 0.15s ease-in-out;
    padding: 0;

    @media ${({ theme }) => theme.breakpoints.mobileLayoutLandscape} {
      display: none;
    }

    &:before,
    &:after {
      display: none;
    }
  }

  &.dc-sticky-hidden,
  &.dc-sticky-sticked {
    position: fixed;

    @media ${({ theme }) => theme.breakpoints.mobileLayoutLandscape} {
      display: none;
    }
  }

  &.dc-sticky-sticked {
    padding: 0;

    .dc-compare-panel {
      margin: 0;
    }
  }
`;

const ComparePanelWrapper = (props) =>
  (props.clientSideRendering ? (
    <Wrapper data-component={'compare-panel'} className={'dc-sticky'}>
      {!props.loadingProducts && <ComparePanel {...props} />}
    </Wrapper>
  ) : null);

ComparePanelWrapper.propTypes = {
  clientSideRendering: PropTypes.bool.isRequired,
  loadingProducts: PropTypes.bool.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  onRemoveProduct: PropTypes.func.isRequired,
  onClearAllButtonClick: PropTypes.func.isRequired,
  onClickProductImage: PropTypes.func.isRequired,
  onCompareButtonClick: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.object)
};

ComparePanelWrapper.defaultProps = {
  products: []
};

function mapStateToProps(state) {
  const currentPageSegmentId =
    Number(getActiveListingPage(state).pageAttributes.filterAttributes.segment_id[0]) ||
    state.listingPage.commonData.category.segmentId;

  return {
    products: state.listingPage.comparison.products[currentPageSegmentId] || [],
    clientSideRendering:
      state.listingPage.browser !== null && typeof state.listingPage.browser.device !== 'undefined',
    isDesktop: state.listingPage.browser
      ? state.listingPage.browser.device.deviceType === 'desktop' ||
        state.listingPage.browser.device.deviceType === 'wide'
      : false,
    loadingProducts: state.listingPage.commonData.xhrStatus.pendingProductsRequest
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onRemoveProduct: (productId) => {
      dispatch(removeProductAndTriggerAnalytics(productId, 'ComparePanel'));
    },
    onClickProductImage: (productId) => {
      dispatchClickProductImage(productId);
    },
    onCompareButtonClick: () => {
      dispatch(showProductsComparision());
    },
    onClearAllButtonClick: () => {
      dispatch(removeAllProductsForSegmentAndTriggerAnalytics());
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ComparePanelWrapper);
